import { useSectionsData } from "../../utils/useSectionsData";
import s from "./style.module.scss";
import { Logo, UsFlag } from "../Icons";
import { getBrandName } from "../../utils/helpers.ts";

export const Header = () => {
  const brandName = getBrandName();
  const sections = useSectionsData();
  const header = sections?.pp_v7_header;

  return (
    <div className={s.header}>
      <div className={s.header__wrapper}>
        <a href="/" className={s.header__link}>
          {header.logo ? (
            <img src={header.logo} width={151} height={32} alt={brandName} />
          ) : (
            <Logo />
          )}
        </a>
        <div className={s.header__right}>
          {header.flag_icon ? (
            <img
              src={header.flag_icon}
              width={41}
              height={24}
              alt={brandName}
            />
          ) : (
            <UsFlag />
          )}
          <div>{header.tr_made_in_label}</div>
        </div>
      </div>
    </div>
  );
};
